import Vue from "vue";
import VueRouter from "vue-router";

import WatchDevice from "../views/watchDevice";
import PBoxDevice from "../views/boxDevice";
import Login from "../views/login/index";
import Home from "../views/home/index";
import Dashboard from "../views/dashboard";
import Project from "../views/ota/project";
import UserManage from "../views/customer/userManage";
import Redeem from "../views/customer/redeem";
import RedeemEmail from "../views/customer/redeemEmail";
import vipManage from "../views/vipCenter/vipManage";
import vipConfiguration from "../views/vipCenter/vipConfiguration";
import equityCenter from "../views/vipCenter/equityCenter";
import collectionRecords from "../views/vipCenter/collectionRecords";
import exchangeRecords from "../views/vipCenter/exchangeRecords";
import paymentRecords from "../views/vipCenter/paymentRecords";
import paymentDetail from "../views/vipCenter/paymentDetail";
import subscribeRecords from "../views/vipCenter/subscribeRecords";
import subscribeDetail from "../views/vipCenter/subscribeDetail";
import vipList from "../views/vipCenter/vipList";
import VipCenter from "../views/customer/vipCenter";
import AppManage from "../views/app/appVersionsList";
import AppPackage from "../views/app/appPackageList";
import AppUniversal from "../views/appUniversal";
import TestAccount from "../views/system/testAccount";
import testForAndroid from "../views/testForAndroid";
import afterSaleManage from "../views/afterSales/afterSaleManage";
import afterSaleOrder from "../views/afterSales/afterSaleOrder";
import Feedback from "../views/customer/feedback";
import OtaList from "../views/ota/OtaList";
import DialList from "../views/ota/DialList";
import OTA from "../views/ota/index";
import Distribution from "@/views/distribution/distribution";
import userDetail from "@/views/user/userDetail";
import Member from "@/views/systemManagement/member";
import Changepwd from "@/views/login/changepwd";
import homePage from "@/views/home/home";
import Role from "@/views/systemManagement/role";
import RoleManage from "@/views/systemManagement/roleManage";
import DevMag from "@/views/dev/deviceManagement";
import personalInfo from "@/views/systemManagement/personalInfo";
import platformRouters from "./platform";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home,
    children: [
      {
        path: "/",
        name: "homePage",
        component: homePage,
      },
      {
        path: "/changepwd",
        name: "changepwd",
        component: Changepwd,
      },
      {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
      },
      {
        path: "/ota",
        name: "ota",
        component: OTA,
      },
      {
        path: "/otaList",
        name: "otaList",
        component: OtaList,
      },
      {
        path: "/dial",
        name: "dial",
        component: DialList,
      },
      {
        path: "/project",
        name: "project",
        component: Project,
      },
      {
        path: "/user",
        name: "user",
        meta: {
          keepAlive: true,
        },
        component: UserManage,
      },
      {
        path: "/redeem",
        name: "redeem",
        component: Redeem,
      },
      {
        path: "/redeemEmail",
        name: "redeemEmail",
        component: RedeemEmail,
      },
      {
        path: "/vipList",
        name: "vipList",
        component: vipList,
      },
      {
        path: "/subscribeRecords",
        name: "subscribeRecords",
        component: subscribeRecords,
      },
      {
        path: "/subscribeDetail",
        name: "subscribeDetail",
        component: subscribeDetail,
      },
      {
        path: "/paymentRecords",
        name: "paymentRecords",
        component: paymentRecords,
      },
      {
        path: "/paymentDetail",
        name: "paymentDetail",
        component: paymentDetail,
      },
      {
        path: "/collectionRecords",
        name: "collectionRecords",
        component: collectionRecords,
      },
      {
        path: "/exchangeRecords",
        name: "exchangeRecords",
        component: exchangeRecords,
      },
      {
        path: "/vipCenter",
        name: "vipCenter",
        component: VipCenter,
      },
      {
        path: "/app",
        name: "app",
        component: AppManage,
      },
      {
        path: "/appPackage",
        name: "appPackage",
        component: AppPackage,
      },
      {
        path: "/testAccount",
        name: "testAccount",
        component: TestAccount,
      },
      {
        path: "/aftersalemanage",
        name: "aftersalemanage",
        // meta: {
        //   keepAlive: true
        // },
        component: afterSaleManage,
      },
      {
        path: "/afterSaleOrder",
        name: "afterSaleOrder",
        // meta: {
        //   keepAlive: true
        // },
        component: afterSaleOrder,
      },
      {
        path: "/feedback",
        name: "feedback",
        meta: {
          keepAlive: true,
        },
        component: Feedback,
      },
      {
        path: "/distribution",
        name: "distribution",
        component: Distribution,
      },
      {
        path: "/userDetail",
        name: "userDetail",
        component: userDetail,
      },
      {
        path: "/userInfo",
        name: "userInfo",
        component: () => import("@/views/user/userInfo"),
      },
      {
        path: "/personalInfo",
        name: "personalInfo",
        component: personalInfo,
      },
      {
        path: "/member",
        name: "member",
        // meta:{
        //   keepAlive:true
        // },
        component: Member,
      },
      {
        path: "/role",
        name: "role",
        component: Role,
      },
      {
        path: "/roleManage",
        name: "roleManage",
        component: RoleManage,
      },
      {
        path: "/marketingCenter",
        name: "marketingCenter",
        component: () => import("@/views/marketingCenter/index"),
      },
      {
        path: "/activeCreat",
        name: "activeCreat",
        component: () => import("@/views/marketingCenter/activeCreat"),
      },
      {
        path: "/activityDetail",
        name: "activityDetail",
        component: () => import("@/views/marketingCenter/activityDetail.vue"),
      },
      {
        path: "/bloodPressure",
        name: "bloodPressure",
        component: () => import("@/views/user/detail/bloodPressure"),
      },
      {
        path: "/HRV",
        name: "HRV",
        component: () => import("@/views/user/detail/HRV"),
      },
      {
        path: "/bloodOx",
        name: "bloodOx",
        component: () => import("@/views/user/detail/bloodOxygen"),
      },
      {
        path: "/heartRate",
        name: "heartRate",
        component: () => import("@/views/user/detail/bloodPreheartRate"),
      },
      {
        path: "/sport",
        name: "sport",
        component: () => import("@/views/user/detail/exercise"),
      },
      {
        path: "/step",
        name: "step",
        component: () => import("@/views/user/detail/step"),
      },
      {
        path: "/heat",
        name: "heat",
        component: () => import("@/views/user/detail/Calories"),
      },
      {
        path: "/sleep",
        name: "sleep",
        component: () => import("@/views/user/detail/sleep"),
      },
      {
        path: "/weight",
        name: "weight",
        component: () => import("@/views/user/detail/weight"),
      },
      {
        path: "/pressure",
        name: "pressure",
        component: () => import("@/views/user/detail/pressure"),
      },
      {
        path: "/dev",
        name: "dev",
        // meta:{
        //   keepAlive:true
        // },
        component: DevMag,
      },
      {
        path: "/devDetail",
        name: "devDetail",
        component: () => import("@/views/dev/devDetail"),
      },
      {
        path: "/feedbackDetail",
        name: "feedbackDetail",
        component: () => import("@/views/customer/feedbackDetail"),
      },
      {
        path: "/vipManage",
        name: "vipManage",
        component: vipManage,
      },
      {
        path: "/equityCenter",
        name: "equityCenter",
        component: equityCenter,
      },
      {
        path: "/vipConfiguration",
        name: "vipConfiguration",
        component: vipConfiguration,
      },
      ...platformRouters,
      // {
      //   path:"/rawData",
      //   name:"rawData",
      //   component:()=> import("@/views/data/rawdata")
      // }
    ],
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/box",
    component: PBoxDevice,
  },
  {
    path: "/watch",
    component: WatchDevice,
  },
  {
    path: "/open-app",
    component: AppUniversal,
  },
  {
    path: "/android",
    component: testForAndroid,
  },
  {
    path: "/bluetooth",
    component: () => import("@/views/bluetooth.vue"),
    meta: {
      title: "蓝牙问题",
    },
  },
  {
    path: "/downLoad",
    component: () => import("@/views/downLoad.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});
const routerPush = router.push;
router.push = (path) => {
  if (typeof path == "string") {
    var obj = {};
    obj.path = path;
    obj.query = {};
    path = obj;
  }
  if (!path.query) {
    path.query = {};
  }

  if (
    (router.currentRoute.path == path.path &&
      JSON.stringify(router.currentRoute.query) ==
      JSON.stringify(path.query)) ||
    path.path == undefined
  ) {
    return;
  } //路由跳转当前路由时不执行该操作

  return routerPush.call(router, path);
};
export default router;
